import React from 'react';
export const RulerStartMarker = () => (React.createElement("svg", { height: "60", viewBox: "0 0 24 24", className: "map_marker" },
    React.createElement("circle", { cx: "12", cy: "12", r: "2", fill: "#ffffff", stroke: "#0b6bf2", strokeWidth: "0.5" })));
//# sourceMappingURL=RulerStartMarker.js.map